export function Row({ label, children }) {
  return (
    <div className="grid grid-cols-[10ch_1fr] gap-2 justify-start items-start text-start ">
      <div className="">{label}</div>
      <div className="font-semibold">{children}</div>
    </div>
  );
}
